export const messages = {
  en: {
    goodCashier: {
      title: 'Goods Cashier',
      productInfo: 'Product Info',
      productImage: 'Product Image',
      productSpec: 'Product Specification',
      unitPrice: 'Unit Price',
      vipPrice: 'VIP Price',
      quantity: 'Quantity',
      discount: 'Discount',
      subtotal: 'Subtotal',
      operation: 'Operation',
      paymentInfo: 'Payment Info',
      vipPhone: 'VIP Phone',
      vipName: 'VIP Name',
      vipGender: 'VIP Gender',
      vipLevel: 'VIP Level',
      coupons: 'Coupons',
      points: 'Points',
      giveCoupons: 'Give Coupons',
      givePoints: 'Give Points',
      consumePoints: 'Consume Points',
      consumeAmount: 'Consume Amount',
      settlement: 'Settlement',
      wechatSettlement: 'WeChat Settlement',
      clear: 'Clear',
      hangOrder: 'Hang Order',
      orderRecords: 'Order Records'
    }
  },
  zh: {
    goodCashier: {
      title: '商品收银',
      productInfo: '商品信息',
      productImage: '商品图片',
      productSpec: '商品规格',
      unitPrice: '单价(元)',
      vipPrice: '会员价(元)',
      quantity: '数量',
      discount: '优惠(元)',
      subtotal: '小计(元)',
      operation: '操作',
      paymentInfo: '支付信息',
      vipPhone: '会员电话',
      vipName: '会员名称',
      vipGender: '会员性别',
      vipLevel: '会员等级',
      coupons: '购物券',
      points: '积分',
      giveCoupons: '赠送优惠卷',
      givePoints: '赠送积分',
      consumePoints: '消费积分',
      consumeAmount: '消费金额',
      settlement: '结算',
      wechatSettlement: '微信结算',
      clear: '清空',
      hangOrder: '挂单',
      orderRecords: '挂单记录'
    }
  }
}